import styled from 'react-emotion';

export const PopupBody = styled.div`
  padding: 26px 84px 18px;
  text-align: center;
  text-transform: none;
  letter-spacing: normal;
  position: relative;
`;

export const BadgeImage = styled.img`
  margin: 0px auto 28px auto;
  display: block;
  max-width: 180px;
  height: auto;
  pointer-events: none;
  user-select: none;
`;

export const BadgeSubText = styled.div`
  ${({ theme }) => `
    font-size: 18px;
    color: ${theme.color.black2};
    margin-bottom: 7px;
  `}
`;

export const BadgeName = styled.div`
  ${({ theme }) => `
    font-size: 32px;
    color: ${theme.color.black1};
    margin-bottom: 43px;
    line-height: 50px;
  `}
`;

export const CloseBtn = styled.div`
  cursor: pointer;
  position: absolute;
  top: 1px;
  right: -23px;

  & svg {
    fill: #929fae;
  }
`;
